import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuthModal from "@/components/AuthModal";
import PromoPopup from "@/components/PromoPopup";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Schedule from "@/pages/Schedule";
import Plans from "@/pages/Plans";
import Packages from "@/pages/Packages";
import Admin from "@/pages/Admin";
import SummerCamp from "@/pages/SummerCamp";
import AuthCallback from "@/components/AuthCallback";

function AppRoutes() {
  const location = useLocation();
  // Synchronous fragment check during render — MUST run before Routes so the OAuth
  // callback is processed first and doesn't race the global auth check.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/schedule" element={<Schedule />} />
      <Route path="/plans" element={<Plans />} />
      <Route path="/packages" element={<Packages />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/summer-camp" element={<SummerCamp />} />
    </Routes>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-court-void">
      <div className="grain-overlay" />
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Navbar />
          <AppRoutes />
          <Footer />
          <AuthModal />
          <PromoPopup />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#1A1D24", border: "1px solid rgba(255,107,0,0.35)", color: "#F8FAFC" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
